export default __webpack_public_path__ + "static/media/CANCELED.e2d13fed.svg";